import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getById, edit, toggleReviewVisibility } from '../../../api/districtapi';
import DistrictSettings from './districtsettings';
import DistrictQuoteRequests from "./quoteRequests";
import DistrictProductLineDiscount from "./districtPrdLIneDis";
import DistrictTypicalLayouts from "./districtTypicalLayouts";
import DistrictSurvey from "./districtSurvey";
import DistrictProducts from './products/DistrictProducts';
import { useDispatch } from 'react-redux';
import { showLoading, hideLoading } from '../../../store/loading-reducer';
import { getDistrictQuotesV2 } from '../../../api/districtquoteapi.js';
import { getLoginUserDetailsV2 } from '../../../api/adminuserapi';
import { updateTitle } from '../../../helpers/titleHelper';
import Schools from "./school";
import Dealers from './dealer';

const districtObj = {
    id: 0,
    name: '',
    hexColor: '#000000',
    path: '',
    mediaItemId: null,
    schoolLogo: null,
    isReviewVisible: true,
}

function EditDistrictDetail() {
    const [activeTab, setActiveTab] = useState('settings');
    const [district, setDistrict] = useState(districtObj);

    const [filter] = useState({ start: 1, length: 100, search: '', status: -1, sort: 0, isdistrictRequest: true });
    const [districtcount, setDistrictcount] = useState(0);
    const [distictUserRoles, setDistictUserRoles] = useState(null);


    const { districtId, openTab } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if (openTab !== undefined) setActiveTab(openTab);
        if (districtId == null) navigate('/admin/districts');

        getDistrictQuotesV2(districtId, filter)
            .then((response) => {
                handleDistrictCount(response?.data?.data?.total);
            });

        dispatch(showLoading());
        if (!district || district.id != districtId) {
            getById(districtId)
                .then((response) => {
                    dispatch(hideLoading());
                    if (response.data.success) {
                        setDistrict({
                            ...response.data.data
                            , isDistrictUser: response.data.isDistrictUser
                            , isDistrictAdmin: response.data.isDistrictAdmin
                        });
                        updateTitle('Admin', response.data.data.name);

                    } else navigate('/admin/districts');
                })
                .catch(ex => {
                    console.log(ex);
                });
        }
    }, []);

    useEffect(() => {
        const fetchUserDetails = async () => {
            dispatch(showLoading());
            try {
                const userResponse = await getLoginUserDetailsV2();
                if (userResponse?.data?.success === true) {
                    if (!userResponse?.data?.isDistrictAdmin && userResponse?.data?.data?.isDistrictApprover && !userResponse?.data?.data.isDistrictAdmin) {
                        setActiveTab("quoterequests");
                    }
                    setDistictUserRoles(userResponse.data);
                }
            } catch (error) {
                console.error("Failed to fetch login user details", error);
            } finally {
                dispatch(hideLoading());
            }
        };

        fetchUserDetails();
    }, []);


    const handleDistrictEdit = (districtData) => {
        if (districtData != undefined && districtData != null) {
            dispatch(showLoading());
            edit({ options: { data: districtData } })
                .then((response) => {
                    dispatch(hideLoading());
                    setDistrict(response.data.data);
                })
        }
    }

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        window.history.replaceState(null, null, '/admin/districts/edit/' + districtId + '/' + tab);
    }

    const handleDistrictCount = (count) => {
        setDistrictcount(count);
    }
    const handleReviewVisibilityChange = async (isVisible) => {
        try {
            await toggleReviewVisibility({ Id: districtId, IsReviewVisible: isVisible });
            setDistrict(prevDistrict => ({
                ...prevDistrict,
                isReviewVisible: isVisible
            }));
        } catch (error) {
            console.error("Failed to update review visibility:", error);
        }
    };

    return (
        <div className="admin-page-wrap">
            <div className="admin-top-bar-wrap">
                <div className="admin-top-bar-left">
                    <a className="admin-top-bar-back" href="/admin/districts">Back</a>
                </div>
            </div>
            <div className="admin-page-content">
                <h1 className="admin-page-heading">{district.name}</h1>
                <div className="admin-tab-wrap">

                    {distictUserRoles && (distictUserRoles?.data?.isDistrictAdmin || distictUserRoles?.isDistrictAdmin) && (
                        <>
                            <button className={`admin-tab ${activeTab === 'settings' ? 'active' : ''}`} onClick={() => handleTabChange('settings')} id="tab1" role="tab" aria-controls="settings-tab" aria-selected="true">Settings</button>
                            <button className={`admin-tab ${activeTab === 'schools' ? 'active' : ''}`} id="tab2" onClick={() => handleTabChange('schools')} role="tab" aria-controls="users-tab" aria-selected="true">Schools</button>
                            <button className={`admin-tab ${activeTab === 'dealers' ? 'active' : ''}`} id="tab2" onClick={() => handleTabChange('dealers')} role="tab" aria-controls="dealers-tab" aria-selected="true">Dealers</button>
                        </>
                    )
                    }
                    {distictUserRoles && (distictUserRoles?.data?.isDistrictAdmin || distictUserRoles?.data?.isDistrictApprover || distictUserRoles?.isDistrictAdmin) && (
                        <button className={`admin-tab ${activeTab === 'quoterequests' ? 'active' : ''}`} id="tab3" role="tab" onClick={() => handleTabChange('quoterequests')} aria-controls="quoterequests-tab" aria-selected="true">Quote Requests {districtcount > 0 ? "(" + districtcount + ")" : "(" + 0 + ")"}</button>
                    )}

                    {distictUserRoles && (distictUserRoles?.data?.isDistrictAdmin || distictUserRoles?.isDistrictAdmin) &&
                        (
                            <>
                                <button className={`admin-tab ${activeTab === 'products' ? 'active' : ''}`} id="tab4" role="tab" aria-controls="products-tab" onClick={() => handleTabChange('products')} aria-selected="true">Products</button>
                                <button className={`admin-tab ${activeTab === 'pricing' ? 'active' : ''}`} id="tab5" role="tab" aria-controls="pricing-tab" onClick={() => handleTabChange('pricing')} aria-selected="true">Pricing</button>
                                <button className={`admin-tab ${activeTab === 'layouts' ? 'active' : ''}`} id="tab6" role="tab" aria-controls="pricing-tab" onClick={() => handleTabChange('layouts')} aria-selected="true">Typical Layouts</button>
                                <button className={`admin-tab ${activeTab === 'surveys' ? 'active' : ''}`} id="tab7" role="tab" aria-controls="surveys-tab" onClick={() => handleTabChange('surveys')} aria-selected="true">Surveys</button>
                            </>
                        )
                    }
                </div>
                {activeTab === 'settings' && <DistrictSettings district={district} onDistrictEdit={handleDistrictEdit} onReviewVisibilityChange={handleReviewVisibilityChange} />}
                {activeTab === 'schools' && <Schools />}
                {activeTab === 'dealers' && <Dealers />}
                {activeTab === 'quoterequests' && <DistrictQuoteRequests district={district} /*handleDistrictCount={handleDistrictCount}*/ />}
                {activeTab === 'pricing' && <DistrictProductLineDiscount />}
                {activeTab === 'layouts' && <DistrictTypicalLayouts />}
                {activeTab === 'products' && <DistrictProducts districtId={districtId} />}
                {activeTab === 'surveys' && <DistrictSurvey />}

            </div>
        </div>
    );
}

export default EditDistrictDetail;